import { Injectable } from "@angular/core";

import { ErrorDialogService } from "./error-dialog/error-dialog.service";
import { Unsubscribable } from "rxjs";
import { DialogType } from "../models/dialog.enum";
import {
  ssgComponentStatus,
  ssgGlobalLogicalPosition,
  ssgGlobalPhysicalPosition,
  ssgGlobalPosition,
  ssgToastrConfig,
} from "../models/ssg-toastr-config";
import { HttpHeaders } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";
import { LocalStoreManager } from "./local-store-manager.service";
import { ToastrService } from "./toaster/public_api";

@Injectable({ providedIn: "root" })
export class ShowToastrService {
  sub: Unsubscribable;
  config: ssgToastrConfig;
  destroyByClick = true;
  duration = 3000;
  hasIcon = true;
  static isLoadingTimeOut: boolean = false;
  position: ssgGlobalPosition = ssgGlobalPhysicalPosition.BOTTOM_LEFT;
  preventDuplicates = false;
  status: ssgComponentStatus = "primary";
  types: ssgComponentStatus[] = ["primary", "success", "info", "warning", "danger"];
  positions: string[] = [
    ssgGlobalPhysicalPosition.TOP_RIGHT,
    ssgGlobalPhysicalPosition.TOP_LEFT,
    ssgGlobalPhysicalPosition.BOTTOM_LEFT,
    ssgGlobalPhysicalPosition.BOTTOM_RIGHT,
    ssgGlobalLogicalPosition.TOP_END,
    ssgGlobalLogicalPosition.TOP_START,
    ssgGlobalLogicalPosition.BOTTOM_END,
    ssgGlobalLogicalPosition.BOTTOM_START,
  ];
  currentTimeOut: number = 1000;
  constructor(
    public toastr: ToastrService,
    protected configurations: ConfigurationService,
    protected localStorage: LocalStoreManager,
    private errorDialogService: ErrorDialogService
  ) {
    this.setCurrentTimeOut();
  }
  showToast(type: ssgComponentStatus, title?: string, body?: string, timeOut?: number, positionClass?: string) {
    if (this.currentTimeOut === 0) return;
    if (!this.currentTimeOut) this.currentTimeOut = 1000;
    const config = {
      timeOut: timeOut ? timeOut : this.currentTimeOut,
      closeButton: true,
      positionClass: positionClass ? positionClass : "toast-bottom-right",
    };
    switch (type) {
      case "danger":
        title = title ? title : "خطا";
        this.toastr.error(body, title, config);
        break;
      case "success":
        title = title ? title : "توجه";
        this.toastr.success(body, title, config);
        break;
      case "warning":
        title = title ? title : "هشدار";
        this.toastr.warning(body, title, config);
        break;
      case "info":
        title = title ? title : "توجه";
        this.toastr.info(body, title, config);
        break;
      case "primary":
        title = title ? title : "توجه";
        this.toastr.show(body, title, config);
        break;
      default:
        title = title ? title : "توجه";
        this.toastr.show(body, title, config);
        break;
    }
  }
  getRequestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[] } } {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return { headers: headers };
  }

  setCurrentTimeOut() {
    if (this.localStorage.getDataObject("ToasterTimeOut") !== undefined) this.currentTimeOut = this.localStorage.getDataObject("ToasterTimeOut");
  }
  showDialog(message: string, title: string);
  showDialog(message: string, title: string, type: DialogType, okCallback: (val?: any) => any);
  showDialog(
    message: string,
    title: string,
    type: DialogType,
    okCallback?: (val?: any) => any,
    cancelCallback?: () => any,
    okLabel?: string,
    cancelLabel?: string,
    defaultValue?: string
  );
  showDialog(
    message: string,
    title: string,
    type?: DialogType,
    okCallback?: (val?: any) => any,
    cancelCallback?: () => any,
    okLabel?: string,
    cancelLabel?: string,
    defaultValue?: string
  ) {
    if (!type) type = DialogType.alert;
    // if (!title)
    //   title = 'پیغام خطا';
    this.errorDialogService.openDialog(title, message, type);
    if (this.sub) this.sub.unsubscribe();
    this.sub = this.errorDialogService.onClose.subscribe((x) => {
      if (x && okCallback) okCallback();
      else if (cancelCallback) {
        cancelCallback();
      }
      this.sub.unsubscribe();
    });
  }
}
